import { Controller } from "@hotwired/stimulus"

// Lazily fetches a Zubie web component JWT from the server and initialises
// the <zubie-trips-map> element. The token expires after 1 hour; re-connecting
// the controller (e.g. Turbo navigation) will re-fetch automatically.
export default class extends Controller {
  static targets = ["map", "loading", "error"]
  static values  = { tokenUrl: String }

  connect() {
    this.loadMap()
  }

  async loadMap() {
    if (!this.hasMapTarget) return

    try {
      const response = await fetch(this.tokenUrlValue, {
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (!response.ok) {
        this.showError(data.error || "Could not load route map")
        return
      }

      const map = this.mapTarget
      map.setAttribute("zubie-token",       data.token)
      map.setAttribute("mapbox-access-token", data.mapbox_token)
      map.setAttribute("vehicle-key",       data.vehicle_key)
      if (data.started_after)  map.setAttribute("started-after",  data.started_after)
      if (data.started_before) map.setAttribute("started-before", data.started_before)

      if (this.hasLoadingTarget) this.loadingTarget.hidden = true
      map.hidden = false

      map.addEventListener("auth-error", () => this.showError("Route map authentication failed"), { once: true })
      map.addEventListener("api-error",  () => this.showError("Could not load route data"),       { once: true })

    } catch (e) {
      this.showError("Could not connect to route service")
    }
  }

  showError(message) {
    if (this.hasLoadingTarget) this.loadingTarget.hidden = true
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.hidden = false
    }
  }
}
